import { PricingTable } from '../pricing-table';
import { SwiperInit } from '../swiper';

void main();

async function main() {
    await PricingTable();

    SwiperInit({
        loop: true,
        centeredSlides: true,
        spaceBetween: 48,
        slideTo: { index: 2, speed: 0 },
    });
}